import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { OUTAGE_REASONS } from '../constants/outageReasons.constants';
import { jsx as _jsx } from "react/jsx-runtime";
const FintechOutagesBannerMessage = ({
  serviceAvailabilityStatus
}) => {
  const reason = serviceAvailabilityStatus.outageReason;
  const endTime = serviceAvailabilityStatus.outageEndTime;
  if (reason === OUTAGE_REASONS.PLANNED_OUTAGE) {
    if (endTime && endTime > new Date().getTime()) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "account-and-billing-fintech-outages.fintech-outage-banner.message.planned-with-end_jsx",
        options: {
          outageEndTime: endTime
        },
        elements: {
          DateTime: FormattedDateTime
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "account-and-billing-fintech-outages.fintech-outage-banner.message.planned"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "account-and-billing-fintech-outages.fintech-outage-banner.message.unplanned"
  });
};
export default FintechOutagesBannerMessage;